import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import FormInputMobile from 'modules/common/components/FormInputMobile';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function OtpSourceModal({
  otpSource,
  isLoading,
  getProfile,
  updateOtpSource,
  profile,
  onSuccess,
}) {
  const setModal = useContext(ModalContext);
  const userEmail = _.get(profile, 'attributes.email', '');
  const userMobileNumber = _.get(profile, 'attributes.mobile_number', '');
  const [formData, setFormData] = useState({
    user_id: '',
    otp_source: otpSource === 'EMAIL_OTP' ? 'MOBILE_NUMBER_OTP' : 'EMAIL_OTP',
  });

  useEffect(() => {
    if (otpSource === 'EMAIL_OTP') {
      setFormData((prev) => ({
        ...prev,
        user_id: userMobileNumber,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      user_id: userEmail,
    }));
  }, [userEmail, userMobileNumber, otpSource]);

  const closeModal = () => setModal({ isOpen: false });

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateOtpSource(formData, () => {
      closeModal();
      getProfile(_.get(profile, 'data.id'));
      onSuccess(formData.user_id);
    });
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form
        onSubmit={handleOnSubmit}
        className="d-flex flex-column align-items-stretch p-3"
        style={{ gap: '.5em' }}
      >
        <div className="form-group w-full">
          <label htmlFor="user_id">
            {otpSource === 'EMAIL_OTP' ? 'Mobile Number' : 'Email'}
          </label>
          {otpSource === 'EMAIL_OTP' ? (
            <FormInputMobile
              disableDropdown={false}
              autoComplete="off"
              autoFocus
              type="tel"
              name="user_id"
              onChange={setFormData}
              value={formData.user_id}
            />
          ) : (
            <input
              name="user_id"
              type="text"
              className="form-control"
              id="user_id"
              onChange={handleOnChange}
              value={formData.user_id}
            />
          )}
        </div>
        {/* <div class="form-group">
          <label htmlFor="user_id">
            {otpSource === 'EMAIL_OTP' ? 'Mobile Number' : 'Email'}
          </label>
          <input
            name="user_id"
            type="text"
            class="form-control"
            id="user_id"
            onChange={handleOnChange}
          />
        </div> */}

        <button
          type="submit"
          disabled={isLoading}
          className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-block btn-signin"
          style={{
            cursor: isLoading ? 'not-allowed' : 'pointer',
          }}
        >
          {isLoading && <i className="fas fa-spin fa-spinner" />} Submit
        </button>

        <button type="button" className="btn btn-link" onClick={closeModal}>
          Cancel
        </button>
      </form>
    </Modal.Body>
  );
}

OtpSourceModal.propTypes = {
  otpSource: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  getProfile: PropTypes.instanceOf(Function).isRequired,
  updateOtpSource: PropTypes.instanceOf(Function).isRequired,
  profile: PropTypes.instanceOf(Object).isRequired,
  onSuccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.DISABLE_2FA) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(OtpSourceModal);
